module.exports = function restAngularConfiguration(RestangularProvider) {
    RestangularProvider.setBaseUrl('/apis/ui');
    RestangularProvider.setRestangularFields({ id: 'Stockcode' });
};



// WEBPACK FOOTER //
// ./src/configuration/restangular.js